import { ValidationProblemResponse } from '@ydistri/api-sdk';
import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react';
import { ApiTags } from './apiLib';
import { serializeQueryArgsWithProjectShortName } from '../lib/project/projectLib';
import { skipToken } from '@reduxjs/toolkit/query';

export const APITAGS = {
  application: {
    projects: 'Projects',
    templates: 'Templates',
    applicationData: 'ApplicationData',
    applicationHints: 'ApplicationHints',
    categoryConfigurationDefinitions: 'CategoryConfigurationDefinitions',
    templateConfiguration: 'TemplateConfiguration',
  },
  globalConfiguration: {
    calculationConfiguration: 'CalculationConfiguration',
  },
  regionFlowGroups: {
    regionFlowGroups: 'RegionFlowGroups',
  },
  validationProblems: {
    validationProblems: 'ValidationProblems',
  },
  calculationDetail: {
    calculation: 'Calculation',
    calculationSinglePickingPosition: 'CalculationSinglePickingPosition',
    calculationPickingPositionWithinProductGroup: 'CalculationPickingPositionWithinProductGroup',
    calculationPickingPositionExecution: 'CalculationPickingPositionExecution',
  },
  calculations: {
    calculations: 'Calculations',
    calculationStatistics: 'CalculationStatistics',
  },
  calculationStatistics: {
    calculationStats: 'CalculationStats',
    redistributionRowCount: 'RedistributionRowCount',
  },
  calculationStatistics2: {
    calculationStats: 'CalculationStats',
    statsRouteSummaries: 'StatsRouteSummaries',
    statsRoutes: 'StatsRoutes',
    statsStoreSummaries: 'StatsStoreSummaries',
    statsSourceStores: 'StatsSourceStores',
    statsRequestStores: 'StatsRequestStores',
    statsRegions: 'StatsRegions',
    statsSkuClasses: 'StatsSkuClasses',
    statsStoreTypes: 'StatsStoreTypes',

    statsRequestListSummary: 'StatsRequestListSummary',
    statsRequestListItems: 'StatsRequestListItems',
    statsRequestListItemSources: 'StatsRequestListItemSources',
  },
  calculationEvaluations: {
    calculationEvaluationSummary: 'CalculationEvaluationSummary',
    calculationFulfillmentSummary: 'CalculationFulfillmentSummary',
    calculationStoreExecutionRates: 'CalculationStoreExecutionRates',
    calculationStoreFulfillmentRates: 'CalculationStoreFulfillmentRates',
    calculationSourceStoreTargetStoresExecutionRates:
      'CalculationSourceStoreTargetStoresExecutionRates',
    calculationSourceStoreCsvFile: 'CalculationSourceStoreCsvFile',
    calculationPackingPictureFile: 'CalculationPackingPictureFile',
  },
  calculationExport: {
    latestCustomExportRun: 'LatestCustomExportRun',
    customExportRuns: 'CustomExportRuns',
    customExportRunItems: 'CustomExportRunItems',
    customExportRunItemDetail: 'CustomExportRunItemDetail',
  },
  calculationPickingResults: {
    calculationPickingResultsSummary: 'CalculationPickingResultsSummary',
    calculationStorePickingResults: 'CalculationStorePickingResults',
    calculationStoreTargetStoresPickingResults: 'CalculationStoreTargetStoresPickingResults',
    calculationPickingInsights: 'CalculationPickingInsights',
    calculationStoreTargetStorePickingInsights: 'CalculationStoreTargetStorePickingInsights',
    calculationPickingInsightsSummary: 'CalculationPickingInsightsSummary',
    calculationPickingIssues: 'CalculationPickingIssues',
    calculationSourceStorePickingIssues: 'CalculationSourceStorePickingIssues',
    calculationPickingIssuesDetails: 'CalculationPickingIssuesDetails',
  },
  calculationRedistributionImport: {
    redistributionImport: 'RedistributionImport',
    redistributionImportItems: 'RedistributionImportItems',
    redistributionImportSummary: 'RedistributionImportSummary',
  },
  balancingConfiguration: {
    balancingConfiguration: 'BalancingConfiguration',
  },
  categoryTree: {
    categoryTree: 'CategoryTree',
  },
  template: {
    categoryConfiguration: 'CategoryConfiguration',
    template: 'Template',
    overlappingCalculations: 'TemplateOverlappingCalculations',
  },
  entityListsAdministration: {
    entityList: 'EntityList',
    entityListsList: 'EntityListsList',
    entityListItems: 'EntityListItems',
    entityListCalculations: 'EntityListCalculations',
    entityListImportSummary: 'EntityListImportSummary',
    entityListImportItems: 'EntityListImportItems',
    entityListItemsCsv: 'EntityListItemsCsv',
  },
  scopesAdministration: {
    scope: 'Scope',
    scopesList: 'ScopesList',
    scopeSkuCount: 'ScopeSkuCount',
    scopeUsages: 'ScopeUsages',
  },
  yPickCredentialsAdministration: {
    yPickCredentials: 'YPickCredentials',
    yPickCredentialsAll: 'YPickCredentialsAll',
  },
  storesScheduleAdministration: {
    storeSchedule: 'StoreSchedule',
    storeSchedulesList: 'StoreSchedulesList',
  },
  storeScheduleExclusions: {
    storeScheduleExclusions: 'StoreScheduleExclusions',
  },
  aiPrompts: {
    aiPrompt: 'AiPrompt',
    aiPromptsList: 'AiPromptsList',
  },
  entityListsAdmin: {
    entityListResponse: 'EntityListResponse',
    entityListSkuResponse: 'EntityListSkuResponse',
    entityListCalculations: 'EntityListCalculations',
  },
  skuClassConfiguration: {
    skuClassConfiguration: 'SkuClassConfiguration',
  },
  brandsConfiguration: {
    brandsConfiguration: 'BrandsConfiguration',
    brandProducts: 'BrandProducts',
  },
  productListConfiguration: {
    productListConfiguration: 'ProductListConfiguration',
    productListConfigurationProducts: 'ProductListConfigurationProducts',
  },
  storeTypeConfiguration: {
    storeTypeConfiguration: 'StoreTypeConfiguration',
  },
  storeConfiguration: {
    storeConfiguration: 'StoreConfiguration',
  },
  calculationCategories: {
    // calculationCategories: 'CalculationCategories',
    calculationCategoryPairings: 'CalculationsCategoryPairings',
  },
  calculationSkus: {
    calculationSkus: 'CalculationSkus',
    calculationSkuMonthlySales: 'CalculationSkuMonthlySales',
    calculationSkuDailySales: 'CalculationSkuDailySales',
    calculationSkuMonthlyForecast: 'CalculationSkuMonthlyForecast',
    skuAttributes: 'SkuAttributes',
  },
  drillDown: {
    categoryOverviewForDrilldown: 'CategoryOverviewForDrilldown',
  },
  identity: {},
  detail: {
    products: 'Products',
    productActivity: 'DetailProductActivity',
    stores: 'Stores',
    skus: 'Skus',
    skuEntityLists: 'skuEntityLists',
    skuCalculationsSource: 'SkuCalculationsSource',
    skuCalculationsTarget: 'SkuCalculationsTarget',
    skuDailySales: 'DetailSkuDailySales',
    skuDailyInbounds: 'DetailSkuDailyInbounds',
    skuDailyOutbounds: 'DetailSkuDailyOutbounds',
    skuAvailableSupplyRanges: 'DetailSkuAvailableSupplyRanges',
    skuDescription: 'SkuDescription',
    productSizes: 'ProductSizes',
  },
  lists: {
    brandsList: 'BrandsList',
    skuClassesList: 'SkuClassesList',
    regionsList: 'RegionsList',
    storesList: 'StoresList',
    storeTypesList: 'StoreTypesList',
    departmentsList: 'DepartmentsList',
  },
  categoryInsights: {
    categoryInsights: 'CategoryInsights',
  },
  scopes: {
    scopes: 'Scopes',
    finalScopeConfigurations: 'FinalScopeConfigurations',
    regionList: 'RegionList',
    storeList: 'StoreList',
    storeTypeList: 'StoreTypeList',
    departmentList: 'DepartmentList',
  },
  calculationEdit: {
    changelog: 'SkuRedistributionChangelog',
  },
  aso: {
    requests: 'AsoRequests',
    list: 'AsoList',
    detail: 'AsoDetail',
    scopes: 'AsoScopes',
    layers: 'AsoLayers',
    storeTierSettings: 'AsoStoreTierSettings',
    storeTiers: 'AsoStoreTiers',
    configuration: 'AsoConfiguration',
    storeTierConfigurations: 'AsoScenarioStoreTierConfigurations',
  },
  ybot: {
    availability: 'YbotAvailability',
    conversations: 'YbotConversations',
    conversation: 'YbotConversation',
    messages: 'YbotMessages',
    ydistriDevsMcpStatus: 'YbotYdistriDevsMcpStatus',
    appMcpStatus: 'YbotAppMcpStatus',
    mcpAuthorization: 'YbotMcpAuthorization',
  },
} as const;

export const apiConfigurationTags: ApiTags[] = [
  APITAGS.categoryTree.categoryTree,
  APITAGS.template.categoryConfiguration,
  APITAGS.regionFlowGroups.regionFlowGroups,
  APITAGS.validationProblems.validationProblems,
  APITAGS.storeConfiguration.storeConfiguration,
  APITAGS.storeTypeConfiguration.storeTypeConfiguration,
  APITAGS.skuClassConfiguration.skuClassConfiguration,
  APITAGS.productListConfiguration.productListConfiguration,
  APITAGS.brandsConfiguration.brandsConfiguration,
  APITAGS.globalConfiguration.calculationConfiguration,
  APITAGS.balancingConfiguration.balancingConfiguration,
  APITAGS.scopes.scopes,
  APITAGS.scopes.finalScopeConfigurations,
  APITAGS.scopes.regionList,
  APITAGS.scopes.storeList,
  APITAGS.scopes.storeTypeList,
  APITAGS.scopes.departmentList,
  APITAGS.storeScheduleExclusions.storeScheduleExclusions,
];

export const getAllTags = (): ApiTags[] => {
  return Object.values(APITAGS)
    .map(group => Object.values(group))
    .flat();
};

export const getAllTagsExcept = (tagsToRemove: ApiTags[]): ApiTags[] => {
  return getAllTags().filter(tag => !tagsToRemove.includes(tag));
};

export type TemplateOrCalculationType = 'Template' | 'Calculation';

export interface TemplateOrCalculation {
  type: TemplateOrCalculationType;
  id: number;
}

export interface TemplateOrCalculationWithValue extends TemplateOrCalculation {
  value: TemplateOrCalculation | typeof skipToken;
  hasValidValue: boolean;
}

export interface ErrorType {
  code: string;
  message: string;
  response: {
    data: {
      // eslint-disable-next-line @typescript-eslint/naming-convention -- mandated by API
      Messages: string[];
      /** The rules that refused the request, when the API sent them. */
      // eslint-disable-next-line @typescript-eslint/naming-convention -- mandated by API
      Problems?: ValidationProblemResponse[];
    };
    status: number;
    statusText: string;
  };
}

/** What an SDK call can reject with: an HTTP refusal with its envelope, or a failure with no response at all. */
export interface ErrorLike {
  code?: string;
  message?: string;
  response?: {
    data?: Partial<ErrorType['response']['data']>;
    status?: number;
    statusText?: string;
  };
}

/**
 * The plain shape RTK stores. A network failure or a timeout has no response; it still gets the
 * whole shape, with its own message as the one flat message, so every reader stays safe.
 */
export const errorTransform = (e: ErrorLike): ErrorType => ({
  code: e.code ?? '',
  message: e.message ?? 'The request failed',
  response: {
    data: {
      // eslint-disable-next-line @typescript-eslint/naming-convention -- mandated by API
      Messages: e.response?.data?.Messages ?? [e.message ?? 'The request failed'],
      // eslint-disable-next-line @typescript-eslint/naming-convention -- mandated by API
      Problems: e.response?.data?.Problems,
    },
    status: e.response?.status ?? 0,
    statusText: e.response?.statusText ?? e.code ?? 'network',
  },
});

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: fakeBaseQuery<ErrorType>(),
  tagTypes: getAllTags(),
  endpoints: () => ({}),
  serializeQueryArgs: ({ endpointName, queryArgs }) =>
    // Only call serializeQueryArgsWithProjectShortName when queryArgs is not skipToken
    queryArgs === skipToken
      ? // return a stable serialized key for skipToken queries
        `${endpointName}|skiptoken`
      : serializeQueryArgsWithProjectShortName(endpointName, queryArgs),
});
